import { createApiActionTypes } from 'store';

export const GET_USER_DETAILS = createApiActionTypes('GET_USER_DETAILS');
export const UPDATE_USER_DETAILS = createApiActionTypes('UPDATE_USER_DETAILS');

export const DELETE_USER_BY_THEMSELVES = createApiActionTypes(
	'DELETE_USER_BY_THEMSELVES',
);

export const GET_LAST_CREATED_SURVEY_LIST = createApiActionTypes(
	'GET_LAST_CREATED_SURVEY_LIST',
);

export const GET_SURVEY_SENT = createApiActionTypes('GET_SURVEY_SENT');

export const CREATE_USER_PASSWORD = createApiActionTypes(
	'CREATE_USER_PASSWORD',
);
export const RESET_PASSWORD_BY_ADMIN = createApiActionTypes(
	'RESET_PASSWORD_BY_ADMIN',
);
export const DELETE_USER_BY_ADMIN = createApiActionTypes(
	'DELETE_USER_BY_ADMIN',
);

export const POST_USER_PHOTO = createApiActionTypes('POST_USER_PHOTO');

export const RESET_RESULT = 'RESET_RESULT';
export const RESET_ERROR = 'RESET_ERROR';

// Survey Tracking
export const GET_TRACKING_SURVEY_LIST = createApiActionTypes(
	'GET_TRACKING_SURVEY_LIST',
);

export const GET_ALL_TRACKING_SURVEY_LIST = createApiActionTypes(
	'GET_ALL_TRACKING_SURVEY_LIST',
);

export const GET_STOP_SURVEY_ROUND = createApiActionTypes(
	'GET_STOP_SURVEY_ROUND',
);

export const DELETE_SURVEY = createApiActionTypes('GET_DELETE_SURVEY');

export const GET_STOP_SURVEY = createApiActionTypes('GET_STOP_SURVEY');

export const GET_SEND_NOTIFICATIONS = createApiActionTypes(
	'GET_SEND_NOTIFICATIONS',
);
export const RESET_NOTIFICATION_ERROR = 'RESET_NOTIFICATION_ERROR';

export const GET_SURVEY_ROUND = createApiActionTypes('GET_SURVEY_ROUND');
export const EDIT_SURVEY_ROUND = createApiActionTypes('EDIT_SURVEY_ROUND');
export const RESET_EDITABLE_ROUND = 'RESET_EDITABLE_ROUND';
export const RESET_IS_ROUND_EDITED = 'RESET_IS_ROUND_EDITED';
export const RESET_ROUND_EDITING_ERROR = 'RESET_ROUND_EDITING_ERROR';

// EMAIL TEMPLATES
export const GET_EMAIL_TEMPLATES_DATA = createApiActionTypes(
	'GET_EMAIL_TEMPLATES_DATA',
);
export const GET_CLIENT_INVITATION_TEMPLATE = createApiActionTypes(
	'GET_CLIENT_INVITATION_TEMPLATE',
);
export const GET_CLIENT_REMINDER_TEMPLATE = createApiActionTypes(
	'GET_CLIENT_REMINDER_TEMPLATE',
);
export const POST_EMAIL_TEMPLATE = createApiActionTypes('POST_EMAIL_TEMPLATE');
export const REPLACE_EMAIL_TEMPLATE = createApiActionTypes(
	'REPLACE_EMAIL_TEMPLATE',
);
export const RESET_EMAIL_EDITING_STATUSES = 'RESET_EMAIL_EDITING_STATUSES';
